export const SIZE = {
    small: 'small',
    medium: 'medium',
};
export const IMAGE_SHAPE = {
    rectangle: 'rectangle',
    circle: 'circle',
};
export const IMAGE_SIZE = {
    tiny: 'tiny',
    small: 'small',
    large: 'large',
    portrait: 'portrait',
    cinema: 'cinema',
};
export const SEARCH_SIZE_BY_SIZE = {
    [SIZE.small]: 'small',
    [SIZE.medium]: 'medium',
};
export const DEFAULT_IMAGE_SIZE_BY_SIZE = {
    [SIZE.small]: IMAGE_SIZE.tiny,
    [SIZE.medium]: IMAGE_SIZE.large,
};
//# sourceMappingURL=constants.js.map